import { useEffect, useRef, useState } from 'react';

import { TextMedium } from 'UiKit/typography';
import getCountUpTimeFormatter from 'Helper/getCountUpTimeFormatter';

const CountTimer = ({ className, prefix, initialTime, isEnabled, variant, onTimeUp, maxMinutes }) => {
  const initialTimer = initialTime >= 0 ? initialTime : 0;
  const [timer, setTimer] = useState(initialTimer);
  const hasCalledTimeUp = useRef(false);

  useEffect(() => {
    hasCalledTimeUp.current = false;
  }, [initialTime]);

  useEffect(() => {
    if (isEnabled) {
      const timer = setInterval(() => {
        if (variant === 'count-up') setTimer((prev) => prev + 1);
        else setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [isEnabled, variant]);

  const time = getCountUpTimeFormatter(timer);

  const isCountDownLimitReached = time === '00:00:00' && variant === 'count-down';
  const isCountUpLimitReached = maxMinutes && timer >= maxMinutes * 60 && variant === 'count-up';

  useEffect(() => {
    if ((isCountUpLimitReached || isCountDownLimitReached) && !hasCalledTimeUp.current) {
      hasCalledTimeUp.current = true;
      onTimeUp?.();
    }
  }, [isCountDownLimitReached, isCountUpLimitReached, onTimeUp]);

  return (
    <TextMedium className={className}>
      {prefix}
      {time}
    </TextMedium>
  );
};

export default CountTimer;
